import Sidemenu from '@blocks/Sidemenu'
import { useSidepanelContext } from '@contexts/sidepanel'
import React from 'react'

export default function SalomLandingSidemenu() {
    const sidemenu = useSidepanelContext()
    
    return (
        <Sidemenu>
            <Sidemenu.Item label="Calendar" to="dates" smooth={true} onClick={sidemenu.close} />
            <Sidemenu.Item label="Judges" to="judges" smooth={true} onClick={sidemenu.close} />
            <Sidemenu.Item label="Support" to="support" smooth={true} onClick={sidemenu.close} />
        </Sidemenu>
    )
}